<template>
  <span>
    <v-dialog v-model="dialog" width="90%">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>{{componentIcon}}</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>{{terminology && terminology.id ? 'Edit Terminology':'New Terminology'}}
          <v-spacer/>
          <v-btn @click="dialog=false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
          <terminology-form ref="terminologyForm" :terminology.sync="terminology" />
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="saveOrUpdateTerminology">{{terminology && terminology.id ? 'Update':'Save'}}</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    terminology: {
      type: Object,
      required: true
    },
    activatorIcon: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dialog: false,
      componentIcon: 'mdi-pencil'
    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading"])
  },
  components: {
    TerminologyForm: () => import("@/components/TerminologyForm.vue")
  },
  mounted() {
    const icon = this.terminology.id ? 'mdi-pencil':'mdi-plus';
    this.componentIcon = this.activatorIcon ? this.activatorIcon:icon;
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    saveOrUpdateTerminology() {
      if (!this.$refs.terminologyForm.$refs.form.validate()) {
        this.addErrorMessage("Please check all required fields are entered");
        return;
      }
      
      this.$axios
        .post("/account/terminology/update", this.terminology)
        .then(resp => {
          console.log(resp.data);
          this.terminology = resp.data;
          this.$emit('updated', this.terminology);
          this.addSuccessMessage('terminology updated');
          this.dialog = false
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    }
  }
};
</script>

<style>
</style>